class CollectionPageSize {
  static ATTRIBUTE = 'collection_page_size';

  constructor() {
    document.addEventListener('click', (event) => {
      const button = event.target.closest('[data-js-page-size]');
      if (!button) return;

      const size = parseInt(button.getAttribute('data-js-page-size'), 10);
      if (!size || button.classList.contains('is-active') || button.disabled) return;

      event.preventDefault();
      this.#setPageSize(size, button);
    });
  }

  async #setPageSize(size, button) {
    const footer = button.closest('[data-js-collection-footer]');
    footer?.classList.add('is-loading');
    button.disabled = true;

    try {
      const root = window.Shopify?.routes?.root || '/';
      const response = await fetch(`${root}cart/update.js`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify({
          attributes: {
            [CollectionPageSize.ATTRIBUTE]: String(size)
          }
        })
      });

      if (!response.ok) throw new Error('Failed to update page size');

      const url = new URL(window.location.href);
      url.searchParams.delete('page');
      window.location.assign(url.pathname + url.search + url.hash);
    } catch (error) {
      footer?.classList.remove('is-loading');
      button.disabled = false;
      console.error(error);
    }
  }
}

window.CollectionPageSize = CollectionPageSize;

if (document.querySelector('[data-js-page-size]')) {
  window.collectionPageSize = new CollectionPageSize();
}
